import { render } from "./GendersCard.vue?vue&type=template&id=4e7aedfc&scoped=true"
import script from "./GendersCard.vue?vue&type=script&lang=js"
export * from "./GendersCard.vue?vue&type=script&lang=js"

import "./GendersCard.vue?vue&type=style&index=0&id=4e7aedfc&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7aedfc"],['__file',"src/components/GendersCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e7aedfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e7aedfc', __exports__)) {
    console.log('reload')
    api.reload('4e7aedfc', __exports__)
  }
  
  module.hot.accept("./GendersCard.vue?vue&type=template&id=4e7aedfc&scoped=true", () => {
    console.log('re-render')
    api.rerender('4e7aedfc', render)
  })

}


export default __exports__